import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { LinkButton, Responsive, UIHeading1, UIHeading2, UIText1, UIText2 } from '@cian/ui-kit';
import * as styles from './PromoOffersList.css';
import { ITEMS_PER_DESKTOP_SCREEN } from '../../constants/promoOffers';
import { PromoOfferCardContainer } from '../../containers/PromoOfferCardContainer';
import { IPromoOffer } from '../../types/promoOffersSelection';
import { PromoOffersListingCard } from '../PromoOffersListingCard';
import { RoundArrowLeft } from '../RoundArrowLeft';
import { RoundArrowRight } from '../RoundArrowRight';
import { VerticalSlider } from '../VerticalSlider';

interface IFreshPromoListProps {
  title: string;
  subtitle: string;
  url: string;
  offers: IPromoOffer[];
  onListShow(): void;
  onListingClick(): void;
  onListingModalClick(): void;
}

export const PromoOffersList: React.FC<IFreshPromoListProps> = ({
  title,
  subtitle,
  url,
  offers,
  onListShow,
  onListingClick,
  onListingModalClick,
}) => {
  return (
    <div data-testid="PromoOffersList">
      <div className={styles['header']}>
        <div className={styles['header-text']}>
          <Responsive desktop tablet>
            <UIHeading1>{title}</UIHeading1>
            <UIText1>{subtitle}</UIText1>
          </Responsive>
          <Responsive phone>
            <UIHeading2>{title}</UIHeading2>
            <UIText2>{subtitle}</UIText2>
          </Responsive>
        </div>
        <Responsive desktop tablet>
          <LinkButton
            href={url}
            target="_blank"
            title="Больше предложений"
            onClick={onListingClick}
            theme="fill_secondary"
            size="XS"
          >
            Больше предложений
          </LinkButton>
        </Responsive>
      </div>
      <ActionAfterViewObserver triggerOnce callback={onListShow} wrapper={false}>
        <div className={styles['container']}>
          <VerticalSlider
            rightArrow={RoundArrowRight}
            leftArrow={RoundArrowLeft}
            itemGap="16px"
            itemsPerDesktopScreen={ITEMS_PER_DESKTOP_SCREEN}
          >
            {offers.map(offer => {
              return (
                <div key={offer.cardId} className={styles['slide']} data-testid="PromoOfferSlide">
                  <PromoOfferCardContainer cardId={offer.cardId} />
                </div>
              );
            })}
            <Responsive desktop>
              {offers.length > ITEMS_PER_DESKTOP_SCREEN && (
                <PromoOffersListingCard onListingClick={onListingModalClick} url={url} />
              )}
            </Responsive>
          </VerticalSlider>
        </div>
      </ActionAfterViewObserver>
      <Responsive phone>
        <div className={styles['listing-button']}>
          <LinkButton
            href={url}
            target="_blank"
            title="Больше предложений"
            onClick={onListingClick}
            theme="fill_secondary"
            size="M"
            fullWidth
          >
            Больше предложений
          </LinkButton>
        </div>
      </Responsive>
    </div>
  );
};
